import { Carousel } from './carousel/carousel';

class LogoCarousel extends Carousel {
  constructor() {
    super();

    this.carousel = new Map();
    super.init(this, '.js-logo-carousel');
  }

  /**
   * Generate config depending of the number of the slides in carousel by extending the default config
   * @returns {Object} extended config
   */
  generateConfig() {
    return super.extendConfig({
      autoplay: true,
      loop: true,
      pagination: false,
      navigation: false,
      slidesPerView: 1,
      centeredSlides: true,
      centeredSlidesBounds: true,
      breakpoints: {
        768: {
          slidesPerView: 3
        }
      }
    });
  }
};

window.HMSLogoCarousel = LogoCarousel;
